module.exports = __webpack_public_path__ + "img/otros-cursos.887798bf.jpg";